import {ALLOWED_IMAGE_TYPES, MAX_IMAGE_SIZE_BYTES} from '../constants/assetUpload'
import {loadImageAsDataUrl} from './spriteUpload'

export type QrLogoLoadErrorKey = 'invalidType' | 'tooLarge' | 'failed'

export class QrLogoLoadError extends Error {
  readonly key: QrLogoLoadErrorKey
  constructor(key: QrLogoLoadErrorKey) {
    super(key)
    this.key = key
  }
}

/** Reads a user-picked center-logo image into a data URL for `qr-code-styling`'s `image` option. */
export const loadQrLogoFile = async (file: File): Promise<string> => {
  if (!ALLOWED_IMAGE_TYPES.has(file.type)) throw new QrLogoLoadError('invalidType')
  if (file.size > MAX_IMAGE_SIZE_BYTES) throw new QrLogoLoadError('tooLarge')
  try {
    return await loadImageAsDataUrl(file)
  } catch {
    throw new QrLogoLoadError('failed')
  }
}
